import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import NavBar from "./components/navbar";
import Header from "./components/header";
import Footer from "./components/footer";
import NotFound from "./components/notFound";  

// USING
import Main from "./components/main"; 
import Language2 from "./components/language2"; 
import Reason from "./components/reason"; 
import Generalregistration from "./components/generalregistration";
import Returncard from "./components/returncard";
import Blacklist from "./components/blacklist";
import GeneralQuestionTwo from "./components/generalquestiontwo";
import SuccessReg from "./components/successreg";
import SuccessReg2 from "./components/successreg2"; 
import Accessdenied from "./components/accessdenied";



import "./App.css";
import "./styles/animation.css";
import "./styles/custom.css";
import 'bootstrap/dist/css/bootstrap.min.css';


class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      show: false,
      showPopup: false
    };

    this.toggleDiv = this.toggleDiv.bind(this)
    this.togglePopup = this.togglePopup.bind(this)
  }

  togglePopup = () => {
    const { showPopup } = this.state;
    this.setState({ showPopup: !showPopup })
  }


  toggleDiv = () => {
    const { show } = this.state;
    this.setState({ show: !show })
  }


  render() {
    return (
      <React.Fragment>

        <div className="toggle">
          <button onClick={this.toggleDiv} className="btn btn-outline-dark">Hide/Show-Navigation</button> 
        </div>


        

        {/* KEYBOARD POP UP  */}
        {/* {this.state.showPopup && <Keyboard />} */}

        <Header />


        <main className="containerBox">
          <div className="contentBox">
            <Switch>
              {/* <Route path="/keyboard" component={Keyboard} /> */} 
              
              <Route path="/generalquestiontwo" component={GeneralQuestionTwo} />
              <Route path="/successreg2" component={SuccessReg2} /> 
              <Route path="/successreg" component={SuccessReg} />
              <Route path="/accessdenied" component={Accessdenied} />
              <Route path="/blacklist" component={Blacklist} />
              <Route path="/generalregistration" component={Generalregistration} />
              <Route path="/returncard" component={Returncard} /> 
              <Route path="/language2" component={Language2} />
              <Route path="/main" component={Main} /> 
              <Route path="/reason" component={Reason} /> 
              <Route path="/not-found" component={NotFound} />
              <Redirect from="/" exact to="/main" />
              <Redirect to="/not-found" />
            </Switch>
          </div>
        </main>

        <Footer />

        {/* TOGGLE SHOW  */}
        {this.state.show && <NavBar />}


      </React.Fragment>
    );
  }
}

export default App;